import { Navigate } from "react-router-dom";
import { FeaturesFlags } from "helpers";
import { useEnvContext } from "contexts";

// Sub-routes in priority order. Add new entries here as new sub-routes are created.
const SUB_ROUTES = [
	{ path: "shop", flag: FeaturesFlags.FRIEND_SHOP },
	{ path: "invite", flag: FeaturesFlags.FRIEND_REFERRAL }
];

export const FriendCenterIndex = () => {
	const { isFeatureFlagEnabled } = useEnvContext();

	const firstEnabled = SUB_ROUTES.find((r) => isFeatureFlagEnabled(r.flag));

	if (firstEnabled) {
		return <Navigate to={firstEnabled.path} replace />;
	}

	// No sub-routes enabled: render nothing, FriendCenter shows its empty state
	return null;
};
